var _style, _path, _path2, _path3, _path4, _rect, _path5, _rect2, _rect3, _rect4, _rect5, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMongolia = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 42",
    style: {
      enableBackground: "new 0 0 64 42"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.mn_st0{fill:#47AECF;}\n\t.mn_st1{fill:#57A863;}\n\t.mn_st2{fill:#DC171C;}\n\t.mn_st3{fill:none;}\n\t.mn_st4{fill:#F2E20E;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_7_copy",
    className: "mn_st0",
    d: "M5.8,0h52.3C61.4,0,64,2.6,64,5.7v30.6c0,3.2-2.6,5.7-5.8,5.7H5.8 C2.6,42,0,39.4,0,36.3V5.7C0,2.6,2.6,0,5.8,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "mn_st1",
    d: "M64,5.3v31.4c0-0.1,0-0.3,0-0.4V5.7C64,5.6,64,5.5,64,5.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "mn_st2",
    d: "M5.8,42h15.5V0H5.8C2.6,0,0,2.6,0,5.7v30.7C0,39.5,2.6,42.1,5.8,42z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "mn_st2",
    d: "M58.2,42H42.7V0h15.5C61.4,0,64,2.6,64,5.7v30.7C64,39.5,61.4,42.1,58.2,42z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 22.1,
    className: "mn_st3",
    width: 0.3,
    height: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "mn_st3",
    d: "M30.5,22.9h0.3v-0.5c0-0.2,0.2-0.5,0.3-0.5c0.1,0,0.3,0.2,0.3,0.5V23h0.3v-1.4h-1.3L30.5,22.9L30.5,22.9z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 23.3,
    className: "mn_st3",
    width: 0.4,
    height: 0.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.8,
    y: 22.7,
    className: "mn_st3",
    width: 0.4,
    height: 0.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32.4,
    y: 22.2,
    className: "mn_st3",
    width: 0.4,
    height: 0.3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 32.1,
    y: 21.8,
    className: "mn_st3",
    width: 0.4,
    height: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "mn_st4",
    cx: 10.8,
    cy: 15.6,
    r: 3.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "mn_st2",
    cx: 10.8,
    cy: 14,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "mn_st4",
    cx: 10.8,
    cy: 14.6,
    r: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "mn_st4",
    d: "M9.1,9.6c0,0.9,0.8,1.7,1.7,1.7s1.7-0.8,1.7-1.7c0-0.7-0.4-0.8-0.4-1c0-0.3,0.3-0.6-0.3-1 C12,8,11.6,8.1,11.6,8.5s0.2,0.4,0.2,0.8c0,0.2-0.2,0.3-0.3,0.3c-0.2,0-0.3-0.2-0.3-0.3c0-0.3,0.3-0.7,0.3-1.2S11.4,7.4,11.1,7 c-0.3-0.4-0.7-0.8-0.3-1.1c-0.5,0.2-0.3,0.8-0.3,1.3s-0.3,0.7-0.3,1.2s0.3,0.6,0.3,0.9c0,0.2-0.2,0.3-0.3,0.3 c-0.2,0-0.3-0.2-0.3-0.3c0-0.3,0.2-0.3,0.2-0.8S9.5,8,9.8,7.6C9.3,8,9.5,8.3,9.5,8.6C9.5,8.8,9.1,8.9,9.1,9.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.4,
    y: 20,
    className: "mn_st4",
    width: 3.4,
    height: 16.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.8,
    y: 20,
    className: "mn_st4",
    width: 3.4,
    height: 16.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.4,
    y: 22.7,
    className: "mn_st4",
    width: 6.7,
    height: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.4,
    y: 32.1,
    className: "mn_st4",
    width: 6.7,
    height: 1.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "mn_st4",
    points: "7.4,20 10.8,22 14.1,20  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "mn_st4",
    points: "7.4,34.1 10.8,36.1 14.1,34.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "mn_st4",
    cx: 10.8,
    cy: 28,
    r: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "mn_st3",
    d: "M10.8,24.5c1,0,1.8,0.8,1.8,1.8s-0.8,1.8-1.8,1.8S9,28.8,9,29.8s0.8,1.8,1.8,1.8"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "mn_st2",
    cx: 10.8,
    cy: 26.3,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "mn_st2",
    cx: 10.8,
    cy: 29.8,
    r: 0.7
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMongolia, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Mongolia.866817ae.svg";
export { ForwardRef as ReactComponent };